import React, {useMemo} from 'react';
import PropTypes from 'prop-types';
import {useTranslation} from 'react-i18next';
import {StyledMatchedTransactionDetails, StyledMatchedTransactionDetailsSpace} from './StyledMatchedTransactionDetails';
import TransactionDetails from '../TransactionDetails';
import EditButton from '../../../EditButton';
import {invoicePaymentStatusConstants} from '../../../../constants';
import {invoicesHelpers} from '../../../../utils/helpers';

const MatchedTransactionDetails = ({
  invoice,
  onEdit,
  transaction,
  ...rest
}) => {
  const [t] = useTranslation('main');

  const { isOutside, matchedTransaction } = useMemo(() => {
    const isOutside = invoice?.payment_status === invoicePaymentStatusConstants.PAID_OUTSIDE;

    const baseTransaction = isOutside
      ? invoicesHelpers.convertInvoiceToTransaction(invoice)
      : transaction;

    const matchedTransaction = isOutside
      ? { ...baseTransaction, source: t('invoices:paidOutsideWithLess') }
      : baseTransaction;

    return { isOutside, matchedTransaction };
  }, [invoice, transaction, t]);

  return (
    <StyledMatchedTransactionDetails
      {...rest}
    >
      <TransactionDetails
        isOutside={isOutside}
        transaction={matchedTransaction}
      />
      <StyledMatchedTransactionDetailsSpace align='center' size='middle'>
        <span>{t('matched')}</span>
        <EditButton
          className='edit-btn'
          onClick={onEdit}
        />
      </StyledMatchedTransactionDetailsSpace>
    </StyledMatchedTransactionDetails>
  );
};

MatchedTransactionDetails.propTypes = {
  invoice: PropTypes.object,
  onEdit: PropTypes.func,
  transaction: PropTypes.object
}

export default MatchedTransactionDetails;
